import axios from "axios";
import api from "../api";
import product_service from "./product-service";
import provider_service from "./provider-service";
import store from "@/store";

function create(params, module) {
  return new Promise(async (resolve, reject) => {
    if (!module) {
      product_service
        .create(params)
        .then(async (product) => {
          store.dispatch("alerts/success", "Módulo criado com sucesso");
          store.dispatch("module/setCreatedProduct", product);
          await createModuleConfigs({ id: product.id, config: params.config })
            .then(async (response) => {
              await provider_service.updateProductSupplier({
                product_id: product.id,
                params: params.suppliers,
              });
              resolve(response);
            })
            .catch((error) => {
              reject(error);
            });
            await product_service.createProductDimensions(product.id,params.dimensions);
        })
        .catch((error) => {
          reject(error);
        });
    } else {
      await createModuleConfigs({ id: module.id, config: params.config })
        .then(async (response) => {
          await provider_service.updateProductSupplier({
            product_id: module.id,
            params: params.suppliers,
          });
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
      await product_service.createProductDimensions(product.id,params.dimensions);
    }
  });
}

function createModuleConfigs(params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${api.products}/${params.id}/module_configs`, {
        module_id: params.id,
        ...params.config,
      })
      .then((response) => {
        store.dispatch(
          "alerts/success",
          "Configurações de Módulo criadas com sucesso"
        );
        store.dispatch("module/setCreatedProduct", false);
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function read(params = {}, id) {
  return {
    modules: await product_service.getProductByCategoryId({
      ...params,
      url_filter: true,
      url_params: { category: id, ...params.url_params },
    }),
  };
}

async function update(params = {}) {
  return new Promise((resolve, reject) => {
    product_service
      .update(params)
      .then(async (product) => {
        store.dispatch("alerts/success", "Módulo editado com sucesso");
        await updateModuleConfigs({ id: params.id, config: params.config });
        await provider_service.updateProductSupplier({
          product_id: params.id,
          params: params.suppliers,
        });
        await product_service.updateProductDimensions(params.id,params.dimensions);
        resolve();
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function updateModuleConfigs(params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .put(`${api.products}/${params.id}/module_configs`, params.config)
      .then((response) => {
        store.dispatch(
          "alerts/success",
          "Configurações de módulo editadas com sucesso"
        );
        resolve({
          module_configs: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function destroy(params = {}) {
  return new Promise(async (resolve, reject) => {
    await destroyModuleConfigs(params);
    axios
      .delete(`${api.products}/${params}`)
      .then((response) => {
        resolve({
          module: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function destroyModuleConfigs(params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .delete(`${api.products}/${params}/module_configs`)
      .then((response) => {
        resolve({
          module_configs: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function getConfigsById(id) {
  return new Promise((resolve, reject) => {
    axios
      .get(`${api.products}/${id}/module_configs`)
      .then((response) => {
        resolve({
          module_configs: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export default {
  read,
  create,
  update,
  destroy,
  getConfigsById,
};
